import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import axios from 'axios';
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'select2';
import 'select2/dist/css/select2.min.css';
import { Tooltip } from 'bootstrap';
window.$ = $;
window.jQuery = $;
const ListPackages = () => {
    const [title, setTitle] = useState('');
    const [type, setType] = useState(0);
    const [loading, setLoading] = useState(false);
    const [package_id, setPackageId] = useState(0);
    const [invoice_number, setInvoiceNumber] = useState(0);
    const [origin_id, setOriginId] = useState(0);
    const [destination_id, setDestinationId] = useState(0);
    const [description_package, setDescripcionPackage] = useState('');
    const [price, setPrice] = useState('');
    const [advance, setAdvance] = useState('');
    const [date_received, setDateReceived] = useState('');
    const [time_received, setTimeReceived] = useState('');
    const [sender, setSender] = useState('');
    const [addressee, setAddressee] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [schedule_id, setScheduleId] = useState(0);
    const [courtesy, setCourtesy] = useState(0);
    const [status, setStatus] = useState(0);
    const [payment_status, setPaymentStatus] = useState(2);
    const [invoice, setInvoice] = useState(0);
    const [send_box_office, setSendBoxOffice] = useState(0);
    const [declared, setDeclared] = useState('');
    const [date_sale, setDateSale] = useState('');
    const [date_send, setDateSend] = useState('');
    const [time_send, setTimeSend] = useState('');
    const [received_box_office, setReceivedBoxOffice] = useState('');
    const [date_deliver, setDateDeliver] = useState('');
    const [packages, setPackages] = useState([]);
    const [origins, setOrigins] = useState([]);
    const [destinations, setDestinations] = useState([]);
    const [processed, setProcessed] = useState(0);
    const [sent, setSent] = useState(0);
    const [received, setReceived] = useState(0);
    const [delivered, setDelivered] = useState(0);
    const [canceled, setCanceled] = useState(0);
    const [collapseFilters, setcollapseFilters] = useState(true);
    const [origin_filter, setOriginFilter] = useState(0);
    const [destination_filter, setDestinationFilter] = useState(0);
    const [status_filter, setStatusFilter] = useState(0);
    const [status_payment_filter, setPaymentStatusFilter] = useState(0);
    const [payment_method, setPaymentMethod] = useState(1);
    const [paymentMethodReceived, setPaymentMethodReceived] = useState(null);
    const [date_filter, setDateFilter] = useState(''); 
    const [startDateFilter, setStartDateFilter] = useState('');
    const [endDateFilter, setEndDateFilter] = useState('');
    const [rol_id, setRolId] = useState(0);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    const tableRef = useRef(null);
    const [datatableActive, setDatatableActive] = useState(false);

    // Helper function to consolidate dual payment fields to single payment method
    // card_payment: 1=tarjeta, 2=efectivo
    // cardPaymentTransfer: 1=transferencia, 2=no-transferencia
    // Returns: 1=Efectivo, 2=Tarjeta, 3=Transferencia
    const determinePaymentMethod = (card_payment, cardPaymentTransfer) => {
        if (card_payment === 1) return 2; // Tarjeta
        if (cardPaymentTransfer === 1) return 3; // Transferencia
        return 1; // Efectivo (default)
    };

    // Helper function to convert single payment method to dual fields for backend
    // Returns: { card_payment, card_payment_transfer }
    const convertPaymentMethodToDualFields = (method) => {
        switch(method) {
            case 2: // Tarjeta
                return { card_payment: 1, card_payment_transfer: 2 };
            case 3: // Transferencia
                return { card_payment: 2, card_payment_transfer: 1 };
            default: // Efectivo
                return { card_payment: 2, card_payment_transfer: 2 };
        }
    };

    // Detectar iOS para aplicar mitigaciones específicas
    const isIOS = () => {
        try {
            return /iP(ad|hone|od)/i.test(navigator.userAgent);
        } catch (err) {
            return false;
        }
    };

    // Bandera de diagnóstico para desactivar DataTables (útil en desktop para pruebas)
    const disableDataTable = !!localStorage.getItem('DISABLE_DATATABLE');

    useEffect(() => {
        // FIRST: Assign rol_id to window IMMEDIATELY before anything else
        const user = JSON.parse(localStorage.getItem('dataUser'));
        if (user && user.rol_id) {
            setRolId(parseInt(user.rol_id));
            window._react_rolId = parseInt(user.rol_id); // Ensure integer comparison
            console.log('DEBUG: Set window._react_rolId =', window._react_rolId, 'Type:', typeof window._react_rolId);
        }

        const initializeData = async () => {
            await getAll();
            await getAllOrigins();
            await getAllDestinations(0);
            
            // Inicializar select2 después de un pequeño delay
            setTimeout(() => {
                initializeSelect2();
                
                // Inicializar DataTable solo si hay datos
                if (packages.length > 0 && !disableDataTable) {
                    initializeDataTable();
                }
            }, 100);
        };

        initializeData();

        return () => {
            // Limpiar DataTable al desmontar
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy();
            }
        };
    }, []);


    const initializeDataTable = () => {
        if (disableDataTable) {
            console.log('DataTable disabled via DISABLE_DATATABLE flag');
            return;
        }

        try {
            const dt = $(tableRef.current).DataTable({
                data: packages,
                columns: [
                    { data: 'invoice_number', className: 'text-center', render: (d) => `<kbd># ${d}</kbd>` },
                    { data: 'origin', className: 'text-left', render: (d) => (d && d.name) ? d.name : '' },
                    { data: 'destination', className: 'text-left', render: (d) => (d && d.name) ? d.name : '' },
                    { data: 'sender', className: 'text-left' },
                    { data: 'addressee', className: 'text-left' },
                    { data: null, className: 'text-center', render: (d) => `${d.date_send || ''} ${d.time_send || ''}` },
                    { data: 'description_package', className: 'text-center' },
                    { data: 'price', className: 'text-center' },
                    { data: 'status', className: 'text-center', render: (s, type, row) => {
                        const cls = s === 1 ? 'status-label-received'
                            : s === 2 ? 'status-label-intransit'
                            : s === 3 ? 'status-label-destination'
                            : s === 4 ? 'status-label-deliver'
                            : s === 5 ? 'status-label-canceled' : '';
                        const text = s === 1 ? 'Recibido' : s === 2 ? 'En Transito' : s === 3 ? 'En Destino' : s === 4 ? 'Entregado' : s === 5 ? 'Cancelado' : '';
                        return `<span class="${cls} p-1 rounded w-100 text-center">${text}</span>`;
                    } },
                    { data: 'payment_status', className: 'text-center', render: (p) => {
                        const cls = p === 1 ? 'status-label-danger' : p === 2 ? 'status-label-success' : '';
                        const text = p === 1 ? 'Por Cobrar' : p === 2 ? 'Pagado' : '';
                        return `<span class="${cls} p-1 rounded w-100 text-center">${text}</span>`;
                    } },
                    { data: null, className: 'text-center', orderable: false, searchable: false, render: function(row) {
                        const viewBtn = `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn btn-sm btn-primary" style="margin-right:2px" onclick="window._react_handleDetail(${row.package_id})"><i class="fas fa-eye"></i></button>`;
                        const changeBtn = `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn btn-sm ${row.status === 4 || row.status === 5 ? 'btn-outline-success' : 'btn-success'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleChangeStatus(${row.package_id})"><i class="fa-solid fa-rotate"></i></button>`;
                        const isAdmin = (() => { try { const u = JSON.parse(localStorage.getItem('dataUser')); return u && parseInt(u.rol_id) === 1; } catch(e) { return parseInt(window._react_rolId) === 1; } })();
                        const editBtn = isAdmin ? `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn-sm btn ${row.status === 4 || row.status === 5 ? 'btn-outline-warning' : 'btn-warning'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleEdit(${row.package_id})"><i class="fa-solid fa-pen-to-square"></i></button>` : '';
                        const cancelBtn = isAdmin ? `<button class="btn-sm btn ${row.status === 4 || row.status === 5 ? 'btn-outline-danger' : 'btn-danger'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleCancel(${row.package_id}, '${(row.description_package||'').replace(/'/g,"\\'")}')"><i class="fa-solid fa-ban"></i></button>` : '';
                        const printBtn = `<button class="btn-sm btn ${row.status === 5 ? 'btn-outline-dark' : 'btn-dark'}" style="margin-right:2px" ${row.status === 5 ? 'disabled' : ''} onclick="window._react_handlePrint(${row.package_id})"><i class="fa-solid fa-print"></i></button>`;
                        const mailBtn = `<button class="btn-sm btn btn-info" style="margin-right:2px" onclick="window._react_handlePrint(${row.package_id})"><i class="fa-solid fa-envelope"></i></button>`;
                        return `<div>${viewBtn}${changeBtn}${editBtn}${cancelBtn}${printBtn}${mailBtn}</div>`;
                    }}
                ],
                searching: true,
                destroy: true,
                retrieve: true,
                pageLength: 50,
                responsive: false,
                autoWidth: false,
                paging: true,
                ordering: false,
                language: {
                    decimal: "",
                    emptyTable: "No hay datos disponibles",
                    info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                    infoEmpty: "Mostrando 0 registros",
                    infoFiltered: "(filtrado de _MAX_ registros totales)",
                    lengthMenu: "Mostrar _MENU_ registros",
                    loadingRecords: "Cargando...",
                    processing: "Procesando...",
                    search: "Buscar:",
                    paginate: {
                      first: "<i class='fa-solid fa-circle-chevron-left'></i>",
                      last: "<i class='fa-solid fa-circle-chevron-right'></i>",
                      next: "<i class='fas fa-arrow-circle-right'></i>",
                      previous: "<i class='fas fa-arrow-circle-left'></i>",
                    },
                    zeroRecords: "No se encontraron coincidencias",
                    searchPlaceholder: "Buscar por número de folio",
                },
                initComplete: function() {
                    try {
                        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                        tooltipTriggerList.map(function(tooltipTriggerEl) {
                          return new Tooltip(tooltipTriggerEl);
                        });
                    } catch (err) { console.warn('Tooltip init error', err); }
                }
            });

            // expose handlers for inline onclick strings
            window._react_handleDetail = (id) => handleDetail(id);
            window._react_handleChangeStatus = (id) => handleChangeStatus(id);
            window._react_handleEdit = (id) => handleEdit(id);
            window._react_handleCancel = (id, name) => handleCancel(id, name);
            window._react_handlePrint = (id) => handlePrint(id);
            window._react_rolId = rol_id;

            setDatatableActive(true);
            return dt;
        } catch (err) {
            console.warn('Failed to initialize DataTable via API', err);
            return;
        }
    };

    // Inicializa o actualiza la DataTable usando los datos proporcionados
    const initializeOrUpdateDataTable = (data) => {
        if (disableDataTable) return;
        const tableEl = tableRef.current;
        try {
            if ($.fn.DataTable.isDataTable(tableEl)) {
                const dt = $(tableEl).DataTable();
                dt.clear();
                dt.rows.add(data);
                dt.draw(false);
                setDatatableActive(true);
                return dt;
            } else {
                // Inicializar usando la API de datos pero con la lista recibida
                try {
                    const dt = $(tableEl).DataTable({
                        data: data,
                        columns: [
                                    { data: 'invoice_number', className: 'text-center', render: (d) => `<kbd># ${d}</kbd>` },
                                    { data: 'origin', className: 'text-left', render: (d) => (d && d.name) ? d.name : '' },
                                    { data: 'destination', className: 'text-left', render: (d) => (d && d.name) ? d.name : '' },
                                    { data: 'sender', className: 'text-left' },
                                    { data: 'addressee', className: 'text-left' },
                                    { data: null, className: 'text-center', render: (d) => `${d.date_send || ''} ${d.time_send || ''}` },
                                    { data: 'description_package', className: 'text-center' },
                                    { data: 'price', className: 'text-center' },
                                    { data: 'status', className: 'text-center', render: (s, type, row) => {
                                        const cls = s === 1 ? 'status-label-received'
                                            : s === 2 ? 'status-label-intransit'
                                            : s === 3 ? 'status-label-destination'
                                            : s === 4 ? 'status-label-deliver'
                                            : s === 5 ? 'status-label-canceled' : '';
                                        const text = s === 1 ? 'Recibido' : s === 2 ? 'En Transito' : s === 3 ? 'En Destino' : s === 4 ? 'Entregado' : s === 5 ? 'Cancelado' : '';
                                        return `<span class="${cls} p-1 rounded w-100 text-center">${text}</span>`;
                                    } },
                                    { data: 'payment_status', className: 'text-center', render: (p) => {
                                        const cls = p === 1 ? 'status-label-danger' : p === 2 ? 'status-label-success' : '';
                                        const text = p === 1 ? 'Por Cobrar' : p === 2 ? 'Pagado' : '';
                                        return `<span class="${cls} p-1 rounded w-100 text-center">${text}</span>`;
                                    } },
                                    { data: null, className: 'text-center', orderable: false, searchable: false, render: function(row) {
                                const viewBtn = `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn btn-sm btn-primary" style="margin-right:2px" onclick="window._react_handleDetail(${row.package_id})"><i class="fas fa-eye"></i></button>`;
                                const changeBtn = `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn btn-sm ${row.status === 4 || row.status === 5 ? 'btn-outline-success' : 'btn-success'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleChangeStatus(${row.package_id})"><i class="fa-solid fa-rotate"></i></button>`;
                                const isAdmin = (() => { try { const u = JSON.parse(localStorage.getItem('dataUser')); return u && parseInt(u.rol_id) === 1; } catch(e) { return parseInt(window._react_rolId) === 1; } })();
                                const editBtn = isAdmin ? `<button data-bs-toggle="modal" data-bs-target="#modal-default" class="btn-sm btn ${row.status === 4 || row.status === 5 ? 'btn-outline-warning' : 'btn-warning'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleEdit(${row.package_id})"><i class="fa-solid fa-pen-to-square"></i></button>` : '';
                                const cancelBtn = isAdmin ? `<button class="btn-sm btn ${row.status === 4 || row.status === 5 ? 'btn-outline-danger' : 'btn-danger'}" style="margin-right:2px" ${row.status === 4 || row.status === 5 ? 'disabled' : ''} onclick="window._react_handleCancel(${row.package_id}, '${(row.description_package||'').replace(/'/g,"\\'")}')"><i class="fa-solid fa-ban"></i></button>` : '';
                                const printBtn = `<button class="btn-sm btn ${row.status === 5 ? 'btn-outline-dark' : 'btn-dark'}" style="margin-right:2px" ${row.status === 5 ? 'disabled' : ''} onclick="window._react_handlePrint(${row.package_id})"><i class="fa-solid fa-print"></i></button>`;
                                const mailBtn = `<button class="btn-sm btn btn-info" style="margin-right:2px" onclick="window._react_handlePrint(${row.package_id})"><i class="fa-solid fa-envelope"></i></button>`;
                                return `<div>${viewBtn}${changeBtn}${editBtn}${cancelBtn}${printBtn}${mailBtn}</div>`;
                            }}
                        ],
                        searching: true,
                        destroy: true,
                        retrieve: true,
                        pageLength: 50,
                        responsive: false,
                        autoWidth: false,
                        paging: true,
                        ordering: false,
                        language: {
                            decimal: "",
                            emptyTable: "No hay datos disponibles",
                            info: "Mostrando _START_ a _END_ de _TOTAL_ registros",
                            infoEmpty: "Mostrando 0 registros",
                            infoFiltered: "(filtrado de _MAX_ registros totales)",
                            lengthMenu: "Mostrar _MENU_ registros",
                            loadingRecords: "Cargando...",
                            processing: "Procesando...",
                            search: "Buscar:",
                            paginate: {
                              first: "<i class='fa-solid fa-circle-chevron-left'></i>",
                              last: "<i class='fa-solid fa-circle-chevron-right'></i>",
                              next: "<i class='fas fa-arrow-circle-right'></i>",
                              previous: "<i class='fas fa-arrow-circle-left'></i>",
                            },
                            zeroRecords: "No se encontraron coincidencias",
                            searchPlaceholder: "Buscar por número de folio",
                        },
                        initComplete: function() {
                            try {
                                const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                                tooltipTriggerList.map(function(tooltipTriggerEl) {
                                  return new Tooltip(tooltipTriggerEl);
                                });
                            } catch (err) { console.warn('Tooltip init error', err); }
                        }
                    });

                    // expose handlers for inline onclick strings
                    window._react_handleDetail = (id) => handleDetail(id);
                    window._react_handleChangeStatus = (id) => handleChangeStatus(id);
                    window._react_handleEdit = (id) => handleEdit(id);
                    window._react_handleCancel = (id, name) => handleCancel(id, name);
                    window._react_handlePrint = (id) => handlePrint(id);
                    window._react_rolId = rol_id;

                    setDatatableActive(true);
                    return dt;
                } catch (err) {
                    console.warn('Failed to initialize DataTable via API', err);
                }
            }
        } catch (err) {
            console.warn('initializeOrUpdateDataTable error', err);
        }
    };
    

    const initializeSelect2 = () => {
        // Solo aplicar select2 si los elementos existen.
        // Evitar inicializar origin/destination cuando estamos en la vista simplificada (type === 2)
        const currentType = type;
        // Destruir instancias previas antes de re-inicializar para evitar duplicados
        // solo iniciar origin/destination si no estamos en la vista simplificada
        if (currentType !== 2) {
            if ($('#origin_id').length > 0) {
                try { if ($('#origin_id').data('select2')) { $('#origin_id').select2('destroy'); $('#origin_id').next('.select2-container').remove(); } } catch (e) {}
                $('#origin_id').select2({
                    width: "100%",
                    dropdownParent: $('#modal-default .modal-content')
                });
            }
            if ($('#destination_id').length > 0) {
                try { if ($('#destination_id').data('select2')) { $('#destination_id').select2('destroy'); $('#destination_id').next('.select2-container').remove(); } } catch (e) {}
                $('#destination_id').select2({
                    width: "100%",
                    dropdownParent: $('#modal-default .modal-content')
                });
            }
        } else {
            // En la vista simplificada asegurarse de eliminar contenedores previos
            try { if ($('#origin_id').data('select2')) { $('#origin_id').select2('destroy'); $('#origin_id').next('.select2-container').remove(); } } catch (e) {}
            try { if ($('#destination_id').data('select2')) { $('#destination_id').select2('destroy'); $('#destination_id').next('.select2-container').remove(); } } catch (e) {}
        }
        if ($('#status').length > 0) {
            try { if ($('#status').data('select2')) { $('#status').select2('destroy'); } } catch (e) {}
            $('#status').select2({
                width: "100%",
                dropdownParent: $('#modal-default .modal-content')
            });
        }
        if ($('#payment_status').length > 0) {
            try { if ($('#payment_status').data('select2')) { $('#payment_status').select2('destroy'); } } catch (e) {}
            $('#payment_status').select2({
                width: "100%",
                dropdownParent: $('#modal-default .modal-content')
            });
        }

        // Para los selects de filtros (fuera del modal)
        if ($('#status_filter').length > 0) {
            $('#status_filter').select2({ width: "100%" });
        }
        if ($('#status_payment_filter').length > 0) {
            $('#status_payment_filter').select2({ width: "100%" });
        }
        if ($('#origin_filter').length > 0) {
            $('#origin_filter').select2({ width: "100%" });
        }
        if ($('#destination_filter').length > 0) {
            $('#destination_filter').select2({ width: "100%" });
        }

        const $select = $('#status');
        if ($select.length > 0) {
            $select.on('change', function (e) {
                const selectedValue = parseInt(e.target.value);
                setStatus(selectedValue);
                var payment_status = $('#payment_status').val();
                if (selectedValue === 4 && payment_status == 1) {
                    var priceseleccioado = $('#price').val();
                    var advanceseleccioado = $('#advance').val();
                    var porcobrar = priceseleccioado != advanceseleccioado ? (parseInt(priceseleccioado) - parseInt(advanceseleccioado)) : '0';
                    console.log([priceseleccioado, advance]);
                    Swal.fire({
                        icon: 'warning',
                        title: 'Cobro pendiente',
                        text: 'Debe cobrar el restante $' + porcobrar + ' porque el paquete no ha sido pagado.',
                        confirmButtonText: 'Entendido',
                    });
                }
            });
        }
    };

    $('#status').on("change", function (e) {
        setStatus(e.target.value);
    });

    $('#payment_status').on("change", function (e) {
        setPaymentStatus(e.target.value);
    });

    $('#origin_filter').on("change", function (e) {
        setOriginFilter(e.target.value);
    });

    $('#destination_filter').on("change", function (e) {
        setDestinationFilter(e.target.value);
    });

    $('#status_filter').on("change", function (e) {
        setStatusFilter(e.target.value);
    });

    $('#status_payment_filter').on("change", function (e) {
        setPaymentStatusFilter(e.target.value);
    });

    const status_package = [
        { label: 'Recibido', value: 1 },
        { label: 'En Transito', value: 2 },
        { label: 'En Destino', value: 3 },
        { label: 'Entregado', value: 4 },
        { label: 'Cancelado', value: 5 }
    ];

    const payment_status_package = [
        { label: 'Por Pagar', value: 1 },
        { label: 'Pagado', value: 2 }
    ];

    const handleCollapse = () => {
        setcollapseFilters(!collapseFilters);
    };

    // Manejadores para filtros de fecha (rango)
    const handleStartDateFilterChange = (e) => {
        setStartDateFilter(e.target.value);
    };

    const handleEndDateFilterChange = (e) => {
        setEndDateFilter(e.target.value);
    };

    const handleSubmit = async (e) => {
    e.preventDefault();
    if (type === 3) {
        setLoading(true);
        const updateData = {
            'schedule_id': schedule_id,
            'origin_id': origin_id,
            'destination_id': destination_id,
            'date_send': date_send,
            'time_send': time_send,
            'description_package': description_package,
            'price': price,
            'advance': advance,
            'sender': sender,
            'addressee': addressee,
            'email': email,
            'phone': phone,
            'payment_status': payment_status,
            'courtesy': courtesy,
            'invoice': invoice,
            'declared': declared
        };
        
        // Solo incluir método de pago si está pagado
        if (payment_status == 2) {
            const { card_payment: cp, card_payment_transfer: cpt } = convertPaymentMethodToDualFields(payment_method);
            updateData.card_payment = cp;
            updateData.card_payment_transfer = cpt;
        }
        
        await axios.put(ENDPOINT + 'update-package/' + package_id, updateData).then(response => {
            getAll();
            setLoading(false);
            $("#closemodal").trigger("click");
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        }).catch(function (error) {
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        });
    } else if (type === 2) {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        
        const updateData = {
            'status': status,
            'payment_status': payment_status,
            'received_box_office': user_id
        };
        
        // Incluir método de pago si está pagado O si está por cobrar y cambio a entregado
        if (payment_status == 2 || (payment_status == 1 && status == 4)) {
            const { card_payment: cp, card_payment_transfer: cpt } = convertPaymentMethodToDualFields(payment_method);
            updateData.card_payment = cp;
            updateData.card_payment_transfer = cpt;
        }
        
        await axios.put(ENDPOINT + 'change-status-package/' + package_id, updateData)
        .then(async response => {
            // Si el estatus cambió a "Entregado" (4), generar PDF de entrega
            if (parseInt(status) === 4) {
                await generateDeliveryPDF(package_id, user_id);
            }
            
            getAll();
            setLoading(false);
            $("#closemodal").trigger("click");
            Swal.fire({
                icon: 'success',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: false,
                timer: 3000,
                html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        }).catch(function (error) {
            console.log(error);
            setLoading(false);
            $("#closemodal").trigger("click");
            Swal.fire({
                icon: 'error',
                title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                showConfirmButton: true,
                html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' }
            });
        });
    }
};

// Agrega esta nueva función para generar el PDF de entrega
const generateDeliveryPDF = async (packageId, userId) => {
    try {
        const form = new FormData();
        form.append("id", packageId);
        form.append("user_id", userId);
        
        const response = await axios.post(ENDPOINT + 'print-pdf-package-delivered', form, { 
            responseType: "blob" 
        });
        
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        
    } catch (error) {
        console.error("Error al generar PDF de entrega:", error);
        // No mostrar error al usuario para no interrumpir el flujo principal
    }
};

    const getAll = async () => {
        setLoading(true);
        const form = new FormData();
        form.append("date_filter", date_filter);
        form.append("start_date_filter", startDateFilter);
        form.append("end_date_filter", endDateFilter);
        form.append("origin_filter", origin_filter);
        form.append("destination_filter", destination_filter);
        form.append("status_filter", status_filter);
        form.append("status_payment_filter", status_payment_filter);
    
        try {
            const response = await axios.post(ENDPOINT + 'get-all-packages', form);
    
                    // Actualizar estados
                    setPackages(response.data.data);
                        setProcessed(response.data.data.filter((e) => e.status === 1).length);
                        setSent(response.data.data.filter((e) => e.status === 2).length);
                        setReceived(response.data.data.filter((e) => e.status === 3).length);
                        setDelivered(response.data.data.filter((e) => e.status === 4).length);
                        setCanceled(response.data.data.filter((e) => e.status === 5).length);

                    // Esperar a que React actualice el DOM y luego refrescar la tabla en lugar de destruir/recrear
                    setTimeout(() => {
                        try {
                            if (!isIOS() && !disableDataTable) {
                                initializeOrUpdateDataTable(response.data.data);
                            }
                        } catch (err) {
                            console.warn('Error updating DataTable after getAll', err);
                        }
                        setLoading(false);
                    }, 100);
        } catch (error) {
          console.error("Error al obtener paquetes:", error);
          setLoading(false);
        }
      };


    const getAllOrigins = async () => {
        const response = await axios.get(ENDPOINT + 'get-all-origins-package');
        const originsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setOrigins(originsArray);
    };

    const getAllDestinations = async (origin_id) => {
        setDestinations([]);
        const response = await axios.get(ENDPOINT + 'get-all-destinations-package/' + origin_id);
        const destinationsArray = response.data.data.map(function (element) {
            return {
                label: element.name,
                value: element.destination_id,
            };
        })
        setDestinations(destinationsArray);
    };

    const handleDetail = async (id) => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-package/' + id).then(response => {
            setLoading(false);
            setType(1);
            setTitle('Detalle del paquete');
            setPackageId(response.data.data.package_id);
            setInvoiceNumber(response.data.data.invoice_number);
            setOriginId(response.data.data.origin_id);
            setDestinationId(response.data.data.destination_id);
            setDescripcionPackage(response.data.data.description_package);
            setPrice(response.data.data.price);
            setAdvance(response.data.data.advance);
            setDateReceived(response.data.data.date_received);
            setTimeReceived(response.data.data.time_received);
            setSender(response.data.data.sender);
            setAddressee(response.data.data.addressee);
            setPhone(response.data.data.phone);
            setScheduleId(response.data.data.schedule_id);
            setCourtesy(response.data.data.courtesy);
            setStatus(response.data.data.status);
            setPaymentStatus(response.data.data.payment_status);
            setInvoice(response.data.data.invoice);
            setSendBoxOffice(response.data.data.name_send_box_office);
            setDeclared(response.data.data.declared);
            setDateSale(response.data.data.date_sale);
            setDateSend(response.data.data.date_send);
            setTimeSend(response.data.data.time_send);
            // Load payment method for different scenarios
            if (response.data.data.payment_status == 2) {
                // Si está pagado, cargar método de pago desde card_payment y cardPaymentTransfer
                const pm = determinePaymentMethod(response.data.data.card_payment, response.data.data.cardPaymentTransfer);
                setPaymentMethod(pm);
                setPaymentMethodReceived(null); // Limpiar el otro estado
            } else if (response.data.data.payment_status == 1) {
                // Si está por cobrar, cargar desde metod_payment_receive
                // metod_payment_receive: 1=Tarjeta, 2=Transferencia, null/undefined=Efectivo
                setPaymentMethod(1); // Reset payment_method
                setPaymentMethodReceived(response.data.data.metod_payment_receive || null);
            } else {
                setPaymentMethod(1); // Reset to default Efectivo
                setPaymentMethodReceived(null);
            }
            setReceivedBoxOffice(response.data.data.name_received_box_office);
            setDateDeliver(response.data.data.date_deliver);
            try { if ($('#origin_id').data('select2')) { $('#origin_id').select2('destroy'); } } catch (e) {}
            try { if ($('#destination_id').data('select2')) { $('#destination_id').select2('destroy'); } } catch (e) {}
            try { if ($('#status').data('select2')) { $('#status').select2('destroy'); } } catch (e) {}
            try { if ($('#payment_status').data('select2')) { $('#payment_status').select2('destroy'); } } catch (e) {}
            setTimeout(() => {
                initializeSelect2();
            }, 100);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        });
    };

    const handleChangeStatus = async (id) => {
        setType(2);
        setLoading(true);

        try {
            const response = await axios.get(ENDPOINT + 'get-package/' + id);
            setLoading(false);
            setTitle('Cambiar estatus del paquete');
            setPackageId(response.data.data.package_id);
            setInvoiceNumber(response.data.data.invoice_number);
            setOriginId(response.data.data.origin_id);
            setDestinationId(response.data.data.destination_id);
            setDescripcionPackage(response.data.data.description_package);
            setPrice(response.data.data.price);
            setAdvance(response.data.data.advance);
            setDateReceived(response.data.data.date_received);
            setTimeReceived(response.data.data.time_received);
            setSender(response.data.data.sender);
            setAddressee(response.data.data.addressee);
            setPhone(response.data.data.phone);
            setScheduleId(response.data.data.schedule_id);
            setCourtesy(response.data.data.courtesy);
            setStatus(response.data.data.status);
            setPaymentStatus(response.data.data.payment_status);
            setInvoice(response.data.data.invoice);
            setSendBoxOffice(response.data.data.name_send_box_office);
            setDeclared(response.data.data.declared);
            setDateSale(response.data.data.date_sale);
            setDateSend(response.data.data.date_send);
            setTimeSend(response.data.data.time_send);
            setReceivedBoxOffice(response.data.data.name_received_box_office);
            setDateDeliver(response.data.data.date_deliver);
            // Load payment method only if payment_status is 2 (Pagado)
            if (response.data.data.payment_status == 2) {
                const pm = determinePaymentMethod(response.data.data.card_payment, response.data.data.cardPaymentTransfer);
                setPaymentMethod(pm);
            } else {
                setPaymentMethod(1); // Reset to default Efectivo
            }
            try { if ($('#origin_id').data('select2')) { $('#origin_id').select2('destroy'); } } catch (e) {}
            try { if ($('#destination_id').data('select2')) { $('#destination_id').select2('destroy'); } } catch (e) {}
            try { if ($('#status').data('select2')) { $('#status').select2('destroy'); } } catch (e) {}
            try { if ($('#payment_status').data('select2')) { $('#payment_status').select2('destroy'); } } catch (e) {}
            setTimeout(() => {
                initializeSelect2();
            }, 100);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const handleEdit = async (id) => {
        setLoading(true);
        await axios.get(ENDPOINT + 'get-package/' + id).then(response => {
            setLoading(false);
            setType(3);
            setTitle('Editar paquete');
            setPackageId(response.data.data.package_id);
            setInvoiceNumber(response.data.data.invoice_number);
            setOriginId(response.data.data.origin_id);
            setDestinationId(response.data.data.destination_id);
            setDescripcionPackage(response.data.data.description_package);
            setPrice(response.data.data.price);
            setAdvance(response.data.data.advance);
            setDateReceived(response.data.data.date_received);
            setTimeReceived(response.data.data.time_received);
            setSender(response.data.data.sender);
            setAddressee(response.data.data.addressee);
            setPhone(response.data.data.phone);
            setScheduleId(response.data.data.schedule_id);
            setCourtesy(response.data.data.courtesy);
            setStatus(response.data.data.status);
            setPaymentStatus(response.data.data.payment_status);
            setInvoice(response.data.data.invoice);
            setSendBoxOffice(response.data.data.name_send_box_office);
            setDeclared(response.data.data.declared);
            setDateSale(response.data.data.date_sale);
            setDateSend(response.data.data.date_send);
            setTimeSend(response.data.data.time_send);
            setReceivedBoxOffice(response.data.data.name_received_box_office);
            setDateDeliver(response.data.data.date_deliver);
            // Load payment method only if payment_status is 2 (Pagado)
            if (response.data.data.payment_status == 2) {
                const pm = determinePaymentMethod(response.data.data.card_payment, response.data.data.cardPaymentTransfer);
                setPaymentMethod(pm);
            } else {
                setPaymentMethod(1); // Reset to default Efectivo
            }
            try { if ($('#origin_id').data('select2')) { $('#origin_id').select2('destroy'); } } catch (e) {}
            try { if ($('#destination_id').data('select2')) { $('#destination_id').select2('destroy'); } } catch (e) {}
            try { if ($('#status').data('select2')) { $('#status').select2('destroy'); } } catch (e) {}
            try { if ($('#payment_status').data('select2')) { $('#payment_status').select2('destroy'); } } catch (e) {}
            setTimeout(() => {
                initializeSelect2();
            }, 100);
        }).catch(function (error) {
            console.log(error)
            setLoading(false);
        });
    };

    const handleCancel = (id, name) => {
        Swal.fire({
            title: `¿Desea cancelar el paquete [ ${name} ] ?`,
            text: "No podrá recuperarlo",
            icon: "warning",
            confirmButtonText: "Sí, cancelarlo",
            confirmButtonColor: "#469408",
            showCancelButton: true,
            cancelButtonColor: "#c71c22",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.put(ENDPOINT + 'cancel-package/' + id, { status: 5 }).then(response => {
                    getAll();
                    setLoading(false);
                    Swal.fire({
                        icon: 'success',
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: false,
                        timer: 3000,
                        html: '<div class="text-custom-alert">' + response.data.msg + '</div>',
                        showClass: { popup: 'animate__animated animate__fadeInDown' },
                        hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                    })
                }).catch(function (error) {
                    setLoading(false);
                    Swal.fire({
                        icon: 'error',
                        title: '<div class="title-custom-alert">' + TITLEALERT + '</div>',
                        showConfirmButton: true,
                        html: '<div class="text-custom-alert">' + error.response.data.msg + '</div>',
                        showClass: { popup: 'animate__animated animate__fadeInDown' },
                        hideClass: { popup: 'animate__animated animate__fadeOutUp' }
                    })
                });
            }
        });
    };

    const handlePrint = async (id) => {
        setLoading(true);
        const user = JSON.parse(localStorage.getItem('dataUser'));
        const user_id = user.user_id;
        const form = new FormData();
        form.append("id", id);
        form.append("user_id", user_id);
        const response = await axios.post(ENDPOINT + 'print-pdf-package', form, { responseType: "blob" });
        const url = window.URL.createObjectURL(response.data);
        window.open(url, '_blank');
        setLoading(false);
    };

    const handleFilterSearch = () => {
        console.log("Aplicando filtros:", {
          origin_filter,
          destination_filter,
          status_filter,
                    status_payment_filter,
                    date_filter,
                    startDateFilter,
                    endDateFilter
        });
        getAll(); // Esto ahora manejará correctamente la actualización
      };

        


    // Agregar esta función de utilidad después de las declaraciones de estado
    const formatDateTime = (dateTimeStr) => {
        if (!dateTimeStr) return '';
        const date = new Date(dateTimeStr);
        return date.toLocaleString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        }).replace(',', '');
    };

    // Refrescar DataTable cuando cambian los paquetes, sin destruirla
    useEffect(() => {
        if (isIOS() || disableDataTable) return;
        const tableEl = tableRef.current;
        if (!tableEl) return;
        if ($.fn.DataTable.isDataTable(tableEl)) {
            try {
                $(tableEl).DataTable().rows().invalidate().draw(false);
            } catch (err) {
                console.warn('Failed to refresh DataTable on packages change', err);
                try {
                    // fallback: re-initialize
                    $(tableEl).DataTable().destroy(true);
                    initializeDataTable();
                } catch (err2) {
                    console.warn('Failed to reinitialize DataTable fallback', err2);
                }
            }
        } else {
            // Initialize after DOM update
            requestAnimationFrame(() => {
                try {
                    initializeDataTable();
                } catch (err) {
                    console.warn('Failed to initialize DataTable on packages change', err);
                }
            });
        }
    }, [packages]);

    return (
        <div>
            {loading && <Loader />}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">{title}</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                {type === 2 ? (
                                    // Vista simplificada para Cambiar Estatus
                                    <>
                                        <div className="list-package-form-header">
                                            <h3 className="list-package-form-title">Cambiar Estado del Paquete</h3>
                                            <p className="list-package-form-subtitle" style={{
                                                borderBottom: '1px solid #dee2e6',
                                                paddingBottom: '10px',
                                                marginBottom: '20px'
                                            }}>Confirme el folio y seleccione el nuevo estado</p>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-sm-12">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">
                                                        Folio del Paquete
                                                    </label>
                                                    <input
                                                        className={`form-control form-control-sm fw-bold`}
                                                        type='text'
                                                        value={`#${invoice_number}`}
                                                        disabled={true}
                                                    />
                                                    <small className="list-package-field-hint">Folio único del paquete</small>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">Origen</label>
                                                    <input
                                                        className={`form-control form-control-sm`}
                                                        type='text'
                                                        value={origins.find(o => o.value === origin_id)?.label || ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">Destino</label>
                                                    <input
                                                        className={`form-control form-control-sm`}
                                                        type='text'
                                                        value={destinations.find(d => d.value === destination_id)?.label || ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">Remitente</label>
                                                    <input
                                                        className={`form-control form-control-sm`}
                                                        type='text'
                                                        value={sender}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">Destinatario</label>
                                                    <input
                                                        className={`form-control form-control-sm`}
                                                        type='text'
                                                        value={addressee}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label htmlFor="status" className="col-form-label col-form-label-sm">
                                                        Nuevo Estado <span className="list-package-required">*</span>
                                                    </label>
                                                    <select
                                                        className="form-control form-control-sm select2"
                                                        id="status"
                                                        name="status"
                                                        value={status}
                                                        required
                                                    >
                                                        {status_package.map((item, index) => (
                                                            <option
                                                                selected={item.value === status}
                                                                key={index}
                                                                value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <small className="list-package-field-hint">Seleccione el nuevo estado</small>
                                                </div>
                                            </div>

                                            <div className="col-12 col-sm-6">
                                                <div className="form-group">
                                                    <label className="col-form-label col-form-label-sm">
                                                        Estado de Pago
                                                    </label>
                                                    <input
                                                        className={`form-control form-control-sm`}
                                                        type='text'
                                                        value={payment_status == 1 ? 'Por Cobrar' : payment_status == 2 ? 'Pagado' : ''}
                                                        disabled={true}
                                                    />
                                                    <small className="list-package-field-hint">Estado actual de pago</small>
                                                </div>
                                            </div>

                                            {payment_status == 1 && (
                                                <div className="col-12 col-sm-6">
                                                    <div className="form-group">
                                                        <label htmlFor="payment_method_status" className="col-form-label col-form-label-sm">
                                                            Método de Pago (Por Cobrar) <span className="list-package-required">*</span>
                                                        </label>
                                                        <select
                                                            className="form-control form-control-sm"
                                                            id="payment_method_status"
                                                            name="payment_method_status"
                                                            value={payment_method}
                                                            onChange={(e) => setPaymentMethod(parseInt(e.target.value))}
                                                            disabled={type === 1 && status === 4 ? true : false}
                                                            required
                                                        >
                                                            <option value="1">Efectivo</option>
                                                            <option value="2">Tarjeta</option>
                                                            <option value="3">Transferencia</option>
                                                        </select>
                                                        <small className="list-package-field-hint">{type === 1 && status === 4 ? 'Método de pago utilizado en entrega' : 'Seleccione el método de pago para la diferencia'}</small>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                ) : (
    // Vista completa para Detalle y Editar
    <>
        <div className="list-package-form-header">
            <h3 className="list-package-form-title">Información del Paquete</h3>
            <p className="list-package-form-subtitle" style={{
                borderBottom: '1px solid #dee2e6',
                paddingBottom: '10px',
                marginBottom: '20px'
            }}>Complete los datos del paquete para su gestión</p>
        </div>
        <div className="row">
            <input type="hidden" onChange={(e) => setPackageId(e.target.value)} value={package_id} />
            <input type="hidden" onChange={(e) => setScheduleId(e.target.value)} value={schedule_id} />
            
            <div className="col-12 col-sm-12">
                <div className="form-group">
                    <label className="col-form-label col-form-label-sm">
                        Folio del Paquete
                    </label>
                    <input
                        className={`form-control form-control-sm fw-bold`}
                        type='text'
                        value={`#${invoice_number}`}
                        disabled={true}
                    />
                    <small className="list-package-field-hint">Folio único del paquete</small>
                </div>
            </div>
            
            <div className="col-12 col-sm-12">
                <div className="form-group">
                    <label htmlFor="description_package" className="col-form-label col-form-label-sm">
                        Descripción del paquete <span className="list-package-required">*</span>
                    </label>
                    <input
                        placeholder="Ingrese descripción del paquete"
                        className={`form-control form-control-sm`}
                        type='text'
                        id='description_package'
                        name="description_package"
                        value={description_package}
                        onChange={(e) => setDescripcionPackage(e.target.value)}
                        disabled={type === 1}
                        required
                    />
                    <small className="list-package-field-hint">Ingrese una descripción detallada del paquete</small>
                </div>
            </div>
            
            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label className="col-form-label col-form-label-sm">Origen</label>
                    <input
                        className={`form-control form-control-sm`}
                        type='text'
                        value={origins.find(o => o.value === origin_id)?.label || ''}
                        disabled={true}
                    />
                    <small className="list-package-field-hint">Ciudad donde se registra el paquete</small>
                </div>
            </div>

            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label className="col-form-label col-form-label-sm">Destino</label>
                    <input
                        className={`form-control form-control-sm`}
                        type='text'
                        value={destinations.find(d => d.value === destination_id)?.label || ''}
                        disabled={true}
                    />
                    <small className="list-package-field-hint">Ciudad donde se entregará el paquete</small>
                </div>
            </div>
            
            {/* Resto de los campos... */}
            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label htmlFor="sender" className="col-form-label col-form-label-sm">
                        Nombre del remitente <span className="list-package-required">*</span>
                    </label>
                    <input
                        className={`form-control form-control-sm`}
                        placeholder="Ingrese nombre del remitente"
                        type='text'
                        value={sender}
                        onChange={(e) => setSender(e.target.value)}
                        id="sender"
                        name="sender"
                        disabled={type === 1}
                        required
                    />
                    <small className="list-package-field-hint">Nombre completo de quien envía el paquete</small>
                </div>
            </div>
            
            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label htmlFor="addressee" className="col-form-label col-form-label-sm">
                        Nombre del destinatario <span className="list-package-required">*</span>
                    </label>
                    <input
                        className={`form-control form-control-sm`}
                        placeholder="Ingrese nombre del destinatario"
                        type='text'
                        value={addressee}
                        onChange={(e) => setAddressee(e.target.value)}
                        id="addressee"
                        name="addressee"
                        disabled={type === 1}
                        required
                    />
                    <small className="list-package-field-hint">Nombre completo de quien recibe el paquete</small>
                </div>
            </div>
            
            {/* Continúa con el resto de los campos que tenías... */}
            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label htmlFor="email" className="col-form-label col-form-label-sm">
                        Email
                    </label>
                    <input
                        className={`form-control form-control-sm`}
                        placeholder="Ingrese email (Opcional)"
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        id="email"
                        name="email"
                        disabled={type === 1}
                    />
                    <small className="list-package-field-hint">Correo electrónico de contacto</small>
                </div>
            </div>
            
            <div className="col-12 col-sm-6">
                <div className="form-group">
                    <label htmlFor="phone" className="col-form-label col-form-label-sm">
                        Teléfono
                    </label>
                    <input
                        className={`form-control form-control-sm`}
                        placeholder="Ingrese teléfono (Opcional)"
                        type='tel'
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        id="phone"
                        name="phone"
                        disabled={type === 1}
                    />
                    <small className="list-package-field-hint">Número de contacto del destinatario</small>
                </div>
            </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="phone" className="col-form-label col-form-label-sm">
                                                Teléfono
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese teléfono (Opcional)"
                                                type='tel'
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                id="phone"
                                                name="phone"
                                                disabled={type === 1 ? true : type === 2 ? true : false}
                                            />
                                            <small className="list-package-field-hint">Número de contacto del destinatario</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date_received" className="col-form-label col-form-label-sm">
                                                Fecha recibido
                                            </label>
                                            <input
                                                placeholder="Fecha recibido"
                                                className={`form-control form-control-sm`}
                                                type='date'
                                                value={date_received}
                                                onChange={(e) => setDateReceived(e.target.value)}
                                                id="date_received"
                                                name="date_received"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Fecha de registro del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="time_received" className="col-form-label col-form-label-sm">
                                                Hora recibido
                                            </label>
                                            <input
                                                placeholder="Hora recibido"
                                                className={`form-control form-control-sm`}
                                                type='time'
                                                value={time_received}
                                                onChange={(e) => setTimeReceived(e.target.value)}
                                                id="time_received"
                                                name="time_received"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Hora de registro del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date_send" className="col-form-label col-form-label-sm">
                                                Fecha envio
                                            </label>
                                            <input
                                                placeholder="Fecha envio"
                                                className={`form-control form-control-sm`}
                                                type='date'
                                                value={date_send}
                                                onChange={(e) => setDateSend(e.target.value)}
                                                id="date_send"
                                                name="date_send"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Fecha de envío del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="time_send" className="col-form-label col-form-label-sm">
                                                Hora envio
                                            </label>
                                            <input
                                                placeholder="Hora envio"
                                                className={`form-control form-control-sm`}
                                                type='time'
                                                value={time_send}
                                                onChange={(e) => setTimeSend(e.target.value)}
                                                id="time_send"
                                                name="time_send"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Hora de envío del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="send_box_office" className="col-form-label col-form-label-sm">
                                                Taquillero que envia
                                            </label>
                                            <input
                                                placeholder="Taquillero que envia"
                                                className={`form-control form-control-sm`}
                                                type='text'
                                                value={send_box_office}
                                                onChange={(e) => setSendBoxOffice(e.target.value)}
                                                id="send_box_office"
                                                name="send_box_office"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Persona que registra el envío del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="received_box_office" className="col-form-label col-form-label-sm">
                                                Taquillero que recibe
                                            </label>
                                            <input
                                                placeholder="Taquillero que recibe"
                                                className={`form-control form-control-sm`}
                                                type='text'
                                                value={received_box_office}
                                                onChange={(e) => setReceivedBoxOffice(e.target.value)}
                                                id="received_box_office"
                                                name="received_box_office"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Persona que recibe el paquete en destino</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date_sale" className="col-form-label col-form-label-sm">
                                                Fecha de venta
                                            </label>
                                            <input
                                                placeholder="Fecha de venta"
                                                className={`form-control form-control-sm`}
                                                type='text'
                                                value={formatDateTime(date_sale)}
                                                onChange={(e) => setDateSale(e.target.value)}
                                                id="date_sale"
                                                name="date_sale"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Fecha en que se registró la venta</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="date_deliver" className="col-form-label col-form-label-sm">
                                                Fecha de entrega
                                            </label>
                                            <input
                                                placeholder="Fecha de entrega"
                                                className={`form-control form-control-sm`}
                                                type='text'
                                                value={formatDateTime(date_deliver)}
                                                onChange={(e) => setDateDeliver(e.target.value)}
                                                id="date_deliver"
                                                name="date_deliver"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Fecha en que se entregó el paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="status" className="col-form-label col-form-label-sm">
                                                Estado del paquete <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="status"
                                                name="status"
                                                value={status}
                                                onChange={(e) => setStatus(parseInt(e.target.value))}
                                                required

                                            >
                                                {status_package.map((item, index) => (
                                                    <option
                                                        selected={item.value === status}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Estado actual del paquete en el sistema</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="payment_status" className="col-form-label col-form-label-sm">
                                                Estado de pago <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="payment_status"
                                                name="payment_status"
                                                value={payment_status}
                                                onChange={(e) => setPaymentStatus(parseInt(e.target.value))}
                                                required
                                            >
                                                {payment_status_package.map((item, index) => (
                                                    <option
                                                        selected={item.value === payment_status}
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Estado de pago actual del envío</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="declared" className="col-form-label col-form-label-sm">
                                                Valor declarado <span className="list-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese valor declarado"
                                                type='text'
                                                value={declared}
                                                onChange={(e) => setDeclared(e.target.value.replace(/[^0-9]/g, ''))}
                                                id="declared"
                                                name="declared"
                                                disabled={type === 1 ? true : type === 2 ? true : false}
                                                required
                                            />
                                            <small className="list-package-field-hint">Valor del contenido del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="price" className="col-form-label col-form-label-sm">
                                                Precio de envío <span className="list-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese precio de envío"
                                                type='text'
                                                value={price}
                                                onChange={(e) => setPrice(e.target.value.replace(/[^0-9]/g, ''))}
                                                id="price"
                                                name="price"
                                                disabled={type === 1 ? true : type === 2 ? true : false}
                                                required
                                            />
                                            <small className="list-package-field-hint">Costo del envío del paquete</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="advance" className="col-form-label col-form-label-sm">
                                                Anticipo <span className="list-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Ingrese anticipo"
                                                type='text'
                                                value={advance}
                                                onChange={(e) => setAdvance(e.target.value.replace(/[^0-9]/g, ''))}
                                                id="advance"
                                                name="advance"
                                                disabled={type === 1 ? true : type === 2 ? true : false}
                                                required
                                            />
                                            <small className="list-package-field-hint">Cantidad de anticipo del envío</small>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-3">
                                        <div className="form-group">
                                            <label htmlFor="courtesy" className="col-form-label col-form-label-sm">
                                                Por Pagar <span className="list-package-required">*</span>
                                            </label>
                                            <input
                                                className={`form-control form-control-sm`}
                                                placeholder="Monto por pagar"
                                                type='text'
                                                value={
                                                    payment_status == "2"
                                                        ? "0"
                                                        : price != advance
                                                            ? (parseInt(price || 0) - parseInt(advance || 0)).toString()
                                                            : "0"
                                                }
                                                id="courtesy"
                                                name="courtesy"
                                                disabled={true}
                                                required
                                            />
                                            <small className="list-package-field-hint">Monto pendiente por pagar </small>
                                        </div>
                                    </div>
                                </div>
                                                

                                


                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="list-package-form-header">
                                            <h4 className="list-package-form-title">
                                                <i className="fa-solid fa-credit-card me-2"></i>
                                                Información de Pago
                                            </h4>
                                            <hr />
                                        </div>
                                    </div>
                                    
                                    {payment_status == 2 && (
                                        <div className="col-12 col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="payment_method" className="col-form-label col-form-label-sm">
                                                    Método de Pago <span className="list-package-required">*</span>
                                                </label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    id="payment_method"
                                                    name="payment_method"
                                                    value={payment_method}
                                                    onChange={(e) => setPaymentMethod(parseInt(e.target.value))}
                                                    disabled={type === 1}
                                                    required
                                                >
                                                    <option value="1">Efectivo</option>
                                                    <option value="2">Tarjeta</option>
                                                    <option value="3">Transferencia</option>
                                                </select>
                                                <small className="list-package-field-hint">Seleccione el método de pago utilizado</small>
                                            </div>
                                        </div>
                                    )}
                                    
                                    {payment_status == 1 && status == 4 && (
                                        <div className="col-12 col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="payment_method_received" className="col-form-label col-form-label-sm">
                                                    Método de Pago (Por Cobrar) <span className="list-package-required">*</span>
                                                </label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    id="payment_method_received"
                                                    name="payment_method_received"
                                                    value={
                                                        paymentMethodReceived == 1 ? "1" :
                                                        paymentMethodReceived == 2 ? "2" :
                                                        "0"
                                                    }
                                                    disabled={true}
                                                    required
                                                >
                                                    <option value="0">Efectivo</option>
                                                    <option value="1">Tarjeta</option>
                                                    <option value="2">Transferencia</option>
                                                </select>
                                                <small className="list-package-field-hint">Método de pago utilizado en entrega</small>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                    </>
                                )}

                                <div className="modal-footer mt-4">
                                    <button
                                        type="submit"
                                        className={`btn btn-success ${type === 1 ? 'd-none' : ''}`} >
                                        <i className="fa-regular fa-floppy-disk me-1"></i>
                                        Actualizar
                                    </button>
                                    <button
                                        id="closemodal"
                                        type="button"
                                        className={`btn ${type === 1 ? 'btn-primary' : 'btn-danger'}`}
                                        data-bs-dismiss="modal">
                                        <i className="fa-solid fa-ban me-1"></i>
                                        {type === 1 ? 'Cerrar' : 'Cancelar'}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="container-fluid">
                <ContentHeader title="Módulo de Paquetería" />
            </div>

            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <div className="indications row">
                            <div className="col-md-6">
                                <h4 className="card-title m-0 page-title">
                                    <i className="bi bi-boxes me-2"></i> Listado de Paquetes
                                </h4>
                            </div>
                            <div className="col-md-6" style={{ textAlign: "right" }}>
                                <Link to="/agregar-paquetes" className="btn btn-success btn-sm me-1">
                                    <i className="fa-solid fa-magnifying-glass-plus me-1"></i> Nueva busqueda
                                </Link>
                                <button
                                    onClick={handleCollapse}
                                    className="btn btn-warning btn-sm me-1"
                                    type="button">
                                    <i className="fa-solid fa-filter me-1"></i> Filtros
                                </button>
                                <button
                                    onClick={() => window.location.reload()}
                                    className="btn btn-info btn-sm me-1"
                                    type="button">
                                    <i className="fa fa-refresh me-1"></i> Recargar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className={`list-package-indications filter ${!collapseFilters ? 'd-none' : ''}`}>
                            <div className="list-package-form-header">
                                <h3 className="list-package-form-title">
                                    <i className="bi bi-funnel me-2"></i>
                                    Filtros de Búsqueda
                                </h3>
                                <p className="list-package-form-subtitle">
                                    Utilice los filtros para encontrar boletos específicos
                                    <hr className="mt-2" />
                                </p>
                            </div>
                            <form>
                                <div className="row mb-4">
                                    

                                    <div className="col-md-2 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="start_date_filter" className="col-form-label col-form-label-sm">
                                                Fecha Desde
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                id="start_date_filter"
                                                name="start_date_filter"
                                                value={startDateFilter}
                                                onChange={handleStartDateFilterChange}
                                            />
                                            <small className="list-package-field-hint">Fecha inicio del rango</small>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="end_date_filter" className="col-form-label col-form-label-sm">
                                                Fecha Hasta
                                            </label>
                                            <input
                                                type="date"
                                                className="form-control form-control-sm"
                                                id="end_date_filter"
                                                name="end_date_filter"
                                                value={endDateFilter}
                                                onChange={handleEndDateFilterChange}
                                            />
                                            <small className="list-package-field-hint">Fecha fin del rango</small>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="origin_filter" className="col-form-label col-form-label-sm">
                                                Origen <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="origin_filter"
                                                name="origin_filter"
                                                onChange={(e) => setOriginFilter(e.target.value)}
                                                required
                                            >
                                                <option value="0">Seleccione</option>
                                                {origins.map((item, index) => (
                                                    <option
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Filtra paquetes por origen</small>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="destination_filter" className="col-form-label col-form-label-sm">
                                                Destino <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="destination_filter"
                                                name="destination_filter"
                                                onChange={(e) => setDestinationFilter(e.target.value)}
                                            >
                                                <option value="0">Seleccione</option>
                                                {destinations.map((item, index) => (
                                                    <option
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Filtra paquetes por destino</small>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="status_filter" className="col-form-label col-form-label-sm">
                                                Estado del paquete <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="status_filter"
                                                name="status_filter"
                                                onChange={(e) => setStatusFilter(e.target.value)}
                                            >
                                                <option value="0">Seleccione</option>
                                                {status_package.map((item, index) => (
                                                    <option
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Filtra por estado actual</small>
                                        </div>
                                    </div>
                                    <div className="col-md-2 col-sm-6 mb-2">
                                        <div className="form-group">
                                            <label htmlFor="status_payment_filter" className="col-form-label col-form-label-sm">
                                                Estado de pago <span className="list-package-required">*</span>
                                            </label>
                                            <select
                                                className="form-control form-control-sm select2"
                                                id="status_payment_filter"
                                                name="status_payment_filter"
                                                onChange={(e) => setPaymentStatusFilter(e.target.value)}
                                            >
                                                <option value="0">Seleccione</option>
                                                {payment_status_package.map((item, index) => (
                                                    <option
                                                        key={index}
                                                        value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>
                                            <small className="list-package-field-hint">Filtra por estado de pago</small>
                                        </div>
                                    </div>
                                    <div className="col-md-12 col-sm-6 mb-3 text-end">
                                    <button
    onClick={handleFilterSearch}
    type="button"
    className="btn btn-primary btn-sm me-1">
    <i className="fa-solid fa-magnifying-glass me-1"></i> Buscar
  </button>
  <button
    onClick={() => {
            setOriginFilter(0);
            setDestinationFilter(0);
            setStatusFilter(0);
            setPaymentStatusFilter(0);
            setDateFilter('');
            setStartDateFilter('');
            setEndDateFilter('');
            getAll(); // Esto cargará todos los registros nuevamente
    }}
    type="button"
    className="btn btn-dark btn-sm">
    <i className="fa-solid fa-eraser me-1"></i> Limpiar
  </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="d-flex justify-content-center align-items-center">
                            <div className="col-lg-12 col-md-6 text-center">
                                <div className="form-group">
                                    <table className="table">
                                        <thead>
                                            <tr className="titstrong text-center">
                                                <td width="16%" className="indications-table">Total</td>
                                                <td width="16%" className="indications-table">Recibidos</td>
                                                <td width="16%" className="indications-table">En Transito</td>
                                                <td width="16%" className="indications-table">En Destino</td>
                                                <td width="16%" className="indications-table">Entregados</td>
                                                <td width="16%" className="indications-table">Cancelados</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td id="TuserTotal">{processed + sent + received + delivered + canceled}</td>
                                                <td id="TuserProc">{processed}</td>
                                                <td id="TuserSend">{sent}</td>
                                                <td id="TuserRece">{received}</td>
                                                <td id="TuserDeli">{delivered}</td>
                                                <td id="TuserCanc">{canceled}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <table ref={tableRef} className="table table-hover main table-striped table-responsive">
                            <thead>
                                <tr>
                                    <th className="text-center">Folio</th>
                                    <th className="text-left">Origen</th>
                                    <th className="text-left">Destino</th>
                                    <th className="text-left">Remitente</th>
                                    <th className="text-left">Destinatario</th>
                                    <th className="text-center">Fecha / Horario</th>
                                    <th className="text-center">Descripcion</th>                                    
                                    <th className="text-center">Precio</th>
                                    <th className="text-center">Estado</th>
                                    <th className="text-center">Pago</th>
                                    <th className="text-center">Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {(!datatableActive || disableDataTable || isIOS()) && packages.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">
                                            <kbd># {item.invoice_number}</kbd>
                                        </td>
                                        <td>
                                            {item.origin && item.origin.name ? item.origin.name : ''}
                                        </td>
                                        <td>
                                            {item.destination && item.destination.name ? item.destination.name : ''}
                                        </td>
                                        <td>
                                            {item.sender}
                                        </td>
                                        <td>
                                            {item.addressee}
                                        </td>
                                        <td className="text-center">
                                            {item.date_send}  {item.time_send}
                                        </td>
                                        <td>
                                            {item.description_package}
                                        </td>
                                        <td className="text-center">
                                            {item.price}
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className={`${item.status === 1
                                                    ? 'status-label-received'
                                                    : item.status === 2
                                                        ? 'status-label-intransit'
                                                        : item.status === 3
                                                            ? 'status-label-destination'
                                                            : item.status === 4
                                                                ? 'status-label-deliver'
                                                                : item.status === 5
                                                                    ? 'status-label-canceled'
                                                                    : ''
                                                    } p-1 rounded w-100 text-center`}
                                            >
                                                {(item.status === 1
                                                    ? 'Recibido'
                                                    : item.status === 2
                                                        ? 'En Transito'
                                                        : item.status === 3
                                                            ? 'En Destino'
                                                            : item.status === 4
                                                                ? 'Entregado'
                                                                : item.status === 5
                                                                    ? 'Cancelado'
                                                                    : ''
                                                )}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <span
                                                className={`${item.payment_status === 1
                                                    ? 'status-label-danger'
                                                    : item.payment_status === 2
                                                        ? 'status-label-success'
                                                        : ''
                                                    } p-1 rounded w-100 text-center`}
                                            >
                                                {(item.payment_status === 1
                                                    ? 'Por Cobrar'
                                                    : item.payment_status === 2
                                                        ? 'Pagado'
                                                        : ''
                                                )}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            <div>
                                                <span
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Detalle del paquete">
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        style={{ marginRight: "2px" }}
                                                        className='btn btn-sm btn-primary'
                                                        onClick={() => handleDetail(item.package_id)}
                                                    >
                                                        <i className="fas fa-eye"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={item.status === 4 ? 'Paquete ya entregado' : 'Cambiar estatus del paquete'}>
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        style={{ marginRight: "2px" }}
                                                        disabled={item.status === 4 || item.status === 5}
                                                        className={`btn btn-sm ${item.status === 4 || item.status === 5 ? 'btn-outline-success' : 'btn-success'}`}
                                                        onClick={() => handleChangeStatus(item.package_id)}
                                                    >
                                                        <i className="fa-solid fa-rotate"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    className={`${rol_id === 1 || rol_id === 2 ? '' : 'd-none'}`}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={item.status === 4 || item.status === 5 ? 'Paquete ya entregado' : 'Editar paquete'}
                                                >
                                                    <button
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#modal-default"
                                                        style={{ marginRight: "2px" }}
                                                        disabled={item.status === 4 || item.status === 5}
                                                        className={`btn-sm btn ${item.status === 4 || item.status === 5 ? 'btn-outline-warning' : 'btn-warning'}`}
                                                        onClick={() => handleEdit(item.package_id)}
                                                    >
                                                        <i className="fa-solid fa-pen-to-square"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    className={`${rol_id === 1 || rol_id === 2 ? '' : 'd-none'}`}
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title={item.status === 4 ? 'Paquete ya entregado' : item.status === 5 ? 'Paquete cancelado' : 'Cancelar paquete'}>
                                                    <button
                                                        style={{ marginRight: "2px" }}
                                                        disabled={item.status === 4 || item.status === 5}
                                                        className={`btn-sm btn ${item.status === 4 || item.status === 5 ? 'btn-outline-danger' : 'btn-danger'}`}
                                                        onClick={() => handleCancel(item.package_id, item.description_package)}
                                                    >
                                                        <i className="fa-solid fa-ban"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    data-bs-toggle="tooltip"
                                                    data-bs-placement="top"
                                                    title="Reimprimir boleto del paquete">
                                                    <button
                                                        data-bs-toggle="tooltip"
                                                        data-bs-placement="top"
                                                        style={{ marginRight: "2px" }}
                                                        disabled={item.status === 5}
                                                        className={`btn-sm btn ${item.status === 5 ? 'btn-outline-dark' : 'btn-dark'}`}
                                                        onClick={() => handlePrint(item.package_id)}
                                                    >
                                                        <i className="fa-solid fa-print"></i>
                                                    </button>
                                                </span>
                                                <span
                                                    data-bs-placement="top"
                                                    title="Reenviar boleto por correo"
                                                    data-bs-toggle="tooltip"
                                                    style={{ marginRight: "2px" }}
                                                >
                                                    <button
                                                        data-bs-toggle="tooltip"
                                                        style={{ marginRight: "2px" }}
                                                        className='btn-sm btn btn-info'
                                                        onClick={() => handlePrint(item.package_id)}
                                                    >
                                                        <i className="fa-solid fa-envelope"></i>
                                                    </button>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ListPackages;